var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg16X16Pin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#262C2E",
    strokeWidth: 1.5,
    d: "M13.25 7c0 2.108-1.335 4.178-2.805 5.796A20 20 0 0 1 8 15.062q-.196-.152-.457-.37a20 20 0 0 1-1.988-1.896C4.085 11.178 2.75 9.108 2.75 7a5.25 5.25 0 1 1 10.5 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1.5,
    fill: "#262C2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16X16Pin);
export default __webpack_public_path__ + "static/media/16x16_pin.d762b1d5229ecbd88e65793103f6e873.svg";
export { ForwardRef as ReactComponent };